import { Grid, TextField } from '@mui/material';
import { Location } from '@thro-types/leihbar';

import { Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export function LocationInformation() {
  const { t } = useTranslation();

  const { errors, touched } = useFormikContext<Location>();

  return (
    <Grid container>
      <Grid item xs={12} marginTop={2}>
        <Field
          as={TextField}
          name="name"
          error={touched.name && errors.name}
          helperText={touched.name && errors.name}
          fullWidth
          required
          label={t(translations.pages.leihbar.location.create.name())}
          size="small"
        />
      </Grid>
    </Grid>
  );
}
